import { MoreVert } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useHasWriteAccess } from '/@/hooks/session';
import { _ } from '/@/locale';
import type { Recommendation } from '/@/types/recommendation';
import DeleteRecommendationModal from '../delete-recommendation-modal';

const RecommendationMoreOptions = ({
    recommendation,
    onClickRedirect,
    downloadRecommendation,
    shareRecommendation,
}: {
    recommendation?: Recommendation;
    onClickRedirect: VoidFunction;
    downloadRecommendation: VoidFunction;
    shareRecommendation: VoidFunction;
}) => {
    const [rowActionsAnchorEl, setRowActionsAnchorEl] = useState<HTMLElement | null>(null);
    const [openDeleteRecommendationModal, setOpenDeleteRecommendationModal] = useState(false);
    const canDeleteRecommendation = useHasWriteAccess();

    const menuItems: {
        label: string;
        onClick: (e: React.MouseEvent<HTMLElement>) => void;
        disabled?: boolean;
        dataTestId?: string;
    }[] = [
        {
            label: _('Ver recomendación'),
            onClick: (e) => {
                onClickRedirect();
            },
            dataTestId: 'recommendation-more-options-view',
            disabled: false,
        },
        {
            label: _('Compartir'),
            onClick: (e) => {
                shareRecommendation();
            },
            disabled: false,
            dataTestId: 'recommendation-more-options-share',
        },
        {
            label: _('Descargar'),
            onClick: (e) => {
                downloadRecommendation();
            },
            disabled: false,
            dataTestId: 'recommendation-more-options-download',
        },
        ...(canDeleteRecommendation
            ? [
                  {
                      label: _('Eliminar'),
                      onClick: (e) => {
                          setOpenDeleteRecommendationModal(true);
                      },
                      disabled: false,
                      dataTestId: 'recommendation-more-options-delete',
                  },
              ]
            : []),
    ];

    return (
        <Box>
            <IconButton
                size='small'
                onClick={(e) => {
                    e.stopPropagation();
                    setRowActionsAnchorEl(e.currentTarget);
                }}
                color='primary'
                data-testid='recommendation-more-options'
            >
                <MoreVert />
            </IconButton>
            <Menu
                open={!!rowActionsAnchorEl}
                onClose={(e) => {
                    e.stopPropagation();
                    setRowActionsAnchorEl(null);
                }}
                anchorEl={rowActionsAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {menuItems.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={(e) => {
                            e.stopPropagation();
                            item.onClick(e);
                            setRowActionsAnchorEl(null);
                        }}
                        disabled={item.disabled}
                        data-testid={item.dataTestId}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
            {recommendation?.id && (
                <DeleteRecommendationModal
                    recommendationId={recommendation?.id}
                    onSuccess={() => {}}
                    open={openDeleteRecommendationModal}
                    setOpen={setOpenDeleteRecommendationModal}
                />
            )}
        </Box>
    );
};

export default RecommendationMoreOptions;
